import style from "./BlogCard.module.scss"
import moment from 'moment';
import DisplayGrid from '../../Atoms/layouts/grid/DisplayGrid';
import parse from 'html-react-parser';

export default function BlogDetailsCard({ className = "", data }) {
  return (
    <div className={`${className} ${style.BlogCard}`}>
      <p className="text-align-right author"><b>{data.author}</b>, <span className="color-666">{moment(data.createdAt).fromNow()}</span></p>
      <img src={data.image.url} className="w-100 mt-10 mb-15" />
      <h4 className="title">{data.title}</h4>
      {/* <p className="mb-10 "></p> */}
      <div className="text_content">{parse(data.content || '')}</div>

    </div>
  )
}